<template>
    <rkm-modal
        class="historico-modal-full"
        :buttons="['cancel']"
        :title="`Paciente: ${paciente.nome}`"
        ref="Modal"
        extraLarge
    >
        <div class="historico-wrapper">
            <rkm-table
                :fields="fields"
                :items="items"
                no-footer-sorting
                sort-by=""
            />
        </div>
    </rkm-modal>
</template>

<script>
// Vuex
import { mapActions } from "vuex";

// Mixins
import { repository, error, data, object, stringCase, file } from "@/mixins";

export default {
    computed: {
        fields() {
            return [
                { key: 'exame', label: 'Exame' },
                { key: 'usuarioCadastro', label: 'Usuário que Cadastrou' },
                { key: 'usuarioAlteracao', label: 'Usuário que Alterou' },
                { key: 'dataHoraModificacao', label: 'Data/hora da Modificação' },
                { key: 'acao', label: 'Ação' },
                { key: 'status', label: 'Status' },
                { key: 'dataHorarioAgendamento', label: 'Data/horário agendamento' },
                { key: 'unidadeColetaNome', label: 'Unidade de coleta' },
                { key: 'laboratorioNome', label: 'Laboratório' },
                { key: 'unidadeResponsavel', label: 'Unidade responsável pela ação' },
                { key: 'justificativa', label: 'Justificativa' },
            ];
        },
    },

    created() {
        this.repositories = {
            agendar: this.getConectaSusRepository('exameLaboratorial.agendamentoExame')
        };
    },

    data: () => ({
        items: [],
    }),

    methods: {
        ...mapActions(["setLoading", "unsetLoading"]),

        load(idAgendamento) {
            this.setLoading();
            this.repositories.agendar
                .getHistoricoExame(idAgendamento)
                .then(({ data }) => {
                    this.items = data;
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading());
        },

        open(idAgendamento) {
            this.items = [];
            this.$refs.Modal.show();
            this.load(idAgendamento);
        },

        save() {
            this.$refs.Modal.hide();
        }
    },

    props: {
        data: { type: Object, required: true },
        paciente: { type: Object, required: true },
    },

    mixins: [repository, error, data, object, stringCase, file],
};
</script>

<style>

.historico-modal-full .modal-xl {
    max-width: 98vw;
}

.historico-modal-full .modal-dialog {
    width: 98vw;
    max-width: 98vw;
}

.historico-wrapper {
    width: 100%;
    overflow-x: auto;
    overflow-y: auto;
}
.historico-wrapper table {
    width: 100%;
    table-layout: auto;
}

.historico-wrapper th,
.historico-wrapper td {
    white-space: normal !important;
    word-break: keep-all;
    overflow-wrap: normal;
}

.historico-wrapper td * {
    white-space: inherit !important;
    word-break: inherit;
    overflow-wrap: inherit;
}

.historico-wrapper th {
    font-weight: 600;
}

</style>